import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  FormControlLabel,
  Switch,
  Typography,
  Box,
  Collapse,
  IconButton,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import moment from "moment";
import { useState } from "react";

export function TareasForm({ DatosForm, frecuencias, handleChange, editMode }) {
  const [resourcesOpen, setResourcesOpen] = useState(
    Boolean(DatosForm.materiales || DatosForm.herramientas)
  );

  return (
    <Box
      sx={{
        mt: 2.5,
        p: 2.5,
        bgcolor: "#f8fafc",
        borderRadius: 2,
        border: "1px solid #e2e8f0",
      }}
    >
      <Typography
        sx={{ display: "block", mb: 2, fontWeight: 700, color: "#0f172a", fontSize: 13 }}
      >
        {editMode ? "Editando tarea" : "Nueva tarea"}
      </Typography>

      <Grid container spacing={2}>
        {/* ── Descripción (campo principal arriba) ── */}
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            size="small"
            label="Descripción de la tarea"
            name="tarea"
            value={DatosForm.tarea}
            onChange={handleChange}
            multiline
            rows={2}
            placeholder="Describí la tarea de mantenimiento a realizar..."
          />
        </Grid>

        {/* ── Programación ─────────────────────────── */}
        <Grid item xs={12}>
          <SectionLabel>Programación</SectionLabel>
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormControl fullWidth required size="small">
            <InputLabel>Frecuencia</InputLabel>
            <Select
              label="Frecuencia"
              name="id_frecuencia"
              value={DatosForm.id_frecuencia}
              onChange={handleChange}
            >
              {(frecuencias ?? []).map((el) => (
                <MenuItem key={el.id} value={el.id}>
                  {el.periodo}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            required
            fullWidth
            size="small"
            label="Último mantenimiento"
            name="ultimo"
            type="date"
            InputLabelProps={{ shrink: true }}
            inputProps={{ max: moment().format("YYYY-MM-DD") }}
            value={DatosForm.ultimo ? moment(DatosForm.ultimo).format("YYYY-MM-DD") : ""}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            required
            fullWidth
            size="small"
            label="Responsable"
            name="responsable"
            value={DatosForm.responsable}
            onChange={handleChange}
            placeholder="Nombre del responsable"
          />
        </Grid>

        {/* ── Recursos (colapsable) ─────────────────── */}
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.25,
              cursor: "pointer",
              width: "fit-content",
              color: resourcesOpen ? "#0f172a" : "#64748b",
              "&:hover": { color: "#0f172a" },
              transition: "color 0.15s",
            }}
            onClick={() => setResourcesOpen((p) => !p)}
          >
            <SectionLabel>
              Recursos
              {!resourcesOpen && DatosForm.materiales ? " · con materiales" : ""}
            </SectionLabel>
            <IconButton size="small" sx={{ p: 0.25, color: "inherit" }}>
              <ExpandMoreIcon
                sx={{
                  fontSize: 15,
                  transform: resourcesOpen ? "rotate(180deg)" : "none",
                  transition: "transform 0.2s ease",
                }}
              />
            </IconButton>
          </Box>
        </Grid>

        <Collapse in={resourcesOpen} style={{ width: "100%", paddingLeft: 16 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={DatosForm.materiales ? 8 : 12}>
              <TextField
                fullWidth
                size="small"
                label="Materiales"
                name="materiales"
                value={DatosForm.materiales}
                onChange={handleChange}
                placeholder="Ej: Aceite 10W30, correas, juntas..."
              />
            </Grid>

            {DatosForm.materiales && (
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Alerta de materiales"
                  name="alerta_material"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: moment().format("YYYY-MM-DD") }}
                  value={
                    DatosForm.alerta_material
                      ? moment(DatosForm.alerta_material).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={handleChange}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Herramientas"
                name="herramientas"
                value={DatosForm.herramientas}
                onChange={handleChange}
                multiline
                rows={2}
                placeholder="Ej: Llave torquímetro, medidor de presión..."
              />
            </Grid>
          </Grid>
        </Collapse>

        {/* ── Requisitos de seguridad ──────────────── */}
        <Grid item xs={12}>
          <SectionLabel>Requisitos de seguridad</SectionLabel>
          <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap", mt: 0.75 }}>
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={Boolean(DatosForm.instructivohsse)}
                  onChange={handleChange}
                  name="instructivohsse"
                />
              }
              label={<Typography variant="body2">Instructivo HSSE</Typography>}
            />
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={Boolean(DatosForm.cert_especial)}
                  onChange={handleChange}
                  name="cert_especial"
                />
              }
              label={<Typography variant="body2">Certificación especial</Typography>}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

function SectionLabel({ children }) {
  return (
    <Typography
      sx={{
        color: "#64748b",
        textTransform: "uppercase",
        letterSpacing: "0.07em",
        fontSize: 10,
        fontWeight: 600,
      }}
    >
      {children}
    </Typography>
  );
}
